/** Readers for loosely typed frame content (JSON from the server). */

export type PlainRecord = Record<string, unknown>;

export function asString(value: unknown): string {
  return typeof value === "string" ? value : "";
}

export function asRecord(value: unknown): PlainRecord | null {
  return value && typeof value === "object" && !Array.isArray(value)
    ? (value as PlainRecord)
    : null;
}

export function compact(parts: string[]): string {
  return parts
    .map((part) => part.trim())
    .filter(Boolean)
    .join("\n\n");
}

export function recordsToText(
  value: unknown,
  render: (record: PlainRecord) => string,
) {
  if (!Array.isArray(value)) return "";
  return value
    .map((item) => asRecord(item))
    .filter((record): record is PlainRecord => record !== null)
    .map(render)
    .join("\n\n");
}
